import { NgModule } from "@angular/core";

import { SharedModule } from "../../shared";
import { ButtonsModule } from "../../components/buttons/buttons.module";
import { MoreOverviewComponent } from "./more-overview/more-overview.component";
import { EditNavigationComponent } from "./edit-navigation/edit-navigation.component";
import { GlossScrollDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.directive";
import { ModalOverlayDirective } from "@bitwarden/web-vault/app/directives/modal-overlay.directive";

@NgModule({
  imports: [GlossScrollDirective, ModalOverlayDirective, SharedModule, ButtonsModule],
  declarations: [MoreOverviewComponent, EditNavigationComponent],
  exports: [MoreOverviewComponent, EditNavigationComponent],
})
export class MobileNavModule {}
